export const of_customs_displayed_columns_locale = {
  type: "Type",
  dateSent: "Date sent",
  dateReady: "Date ready",
  messageStatus: "Status",
};
